<template>
  <div class="intention-box-main cvs-intention">
    <!-- <transition name=""> -->
      <div class="box" v-if="show" :style="{height: is_student ? '458px' : '598px'}">
        <i class="close iconfont iconx" v-if="isClose" @click.stop="$emit('close');"></i>
        <div class="name">求职意向</div>
        <!-- <div class="message">填写求职意向，HR更容易看到你的简历哦～</div> -->

        <div class="title">行业领域</div>
        <select-box>
          <template v-slot:input>
            <div class="industries-input">
              <div
                class="item"
                v-for="(item, index) in industrie"
                :key="index">
                {{item}}
                <div class="item-clone" @click.stop="selectIndustrie(item)" v-if="item !== '不限'">
                  <img src="https://files.wondercv.com/cvsvue/jobs_delete.png">
                </div>
                </div>
            </div>
          </template>
          <template v-slot:content>
            <div class="industries">
              <div
                :class="['item', industrie && industrie.indexOf(item.cn) !== -1 ? 'active' : '']"
                v-for="(item, index) in conditionsData.industries"
                :key="index"
                @click="selectIndustrie(item.cn)">
                  {{item.cn}}
                </div>
            </div>
          </template>
        </select-box>

        <div class="title">工作地点</div>
        <select-box>
          <template v-slot:input>
            <div class="industries-input">
              <div
                class="item"
                v-for="(item, index) in citie"
                :key="index">
                {{item}}
                <div class="item-clone" @click.stop="selectCitie(item)" v-if="item !== '全国'">
                  <img src="https://files.wondercv.com/cvsvue/jobs_delete.png">
                </div>
                </div>
            </div>
          </template>
          <template v-slot:content>
            <div class="city">
              <div class="left-model">
                <div
                  :class="['item', citiesIndex === index ? 'active' : '']"
                  v-for="(item, index) in cityList"
                  :key="index"
                  @click="citiesIndex = index"
                  v-show="item.group_name !== '其他'">
                  {{item.group_name}}
                  </div>
              </div>
              <div class="right-model" v-if="cityList[citiesIndex]">
                <div
                  :class="['menu', citie.indexOf(item.city_name || item.cn) !== -1 ? 'active' : '']"
                  v-for="(item, index) in cityList[citiesIndex].part_cities"
                  :key="item.id"
                  @click="selectCitie(item.city_name || item.cn)">
                  {{item.city_name || item.cn}}
                </div>
              </div>
            </div>
          </template>
        </select-box>

        <div class="title">职位类型</div>
        <select-box>
          <template v-slot:input>
            <div class="industries-input">
              <div
                class="item"
                v-for="(item, index) in categorie"
                :key="index">
                {{item}}
                <div class="item-clone" @click.stop="selectCategorie(item)" v-if="item !== '不限'">
                  <img src="https://files.wondercv.com/cvsvue/jobs_delete.png">
                </div>
                </div>
            </div>
          </template>
          <template v-slot:content>
            <div class="industries">
              <div
                :class="['item', categorie && categorie.indexOf('不限') !== -1 ? 'active' : '']"
                @click="selectCategorie('不限')">
                  不限
                </div>
              <div
                :class="['item', categorie.indexOf(item.name) !== -1 ? 'active' : '']"
                v-for="(item, index) in conditionsData.professions"
                :key="index"
                @click="selectCategorie(item.name)">
                  {{item.name}}
                </div>
            </div>
          </template>
        </select-box>
        <!-- <div class="title">工作类型</div>
        <div class="type">
          <div
            :class="['type-item', item === work_time ? 'active' : '']"
            v-for="(item, index) in work_time_all"
            :key="index"
            @click="work_time = item">
            {{item}}
          </div>
        </div> -->
        <div v-if="!is_student">
          <div class="title">期望薪资</div>
          <div class="salary">
            <label class="salary-item">
              <el-select v-model="expect_min_salary" placeholder="请选择" @change="min => (minChange(min),isActive())">
                <el-option
                  v-for="item in 100"
                  :key="item"
                  :label="item === 100 ? '100k以上' : item"
                  :value="item">
                </el-option>
              </el-select>
              <div class="salary-item-text">K/月</div>
            </label>
            <div class="salary-text" v-if="expect_min_salary < 100">至</div>
            <label class="salary-item" v-if="expect_min_salary < 100">
              <el-select v-model="expect_max_salary" placeholder="请选择" @change="isActive">
                <el-option
                  v-for="item in 100"
                  v-if="item > expect_min_salary && item <= expect_min_salary * 2"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
              <div class="salary-item-text">K/月</div>
            </label>
          </div>
          <div class="title">当前状态</div>
          <div class="type">
            <div
              :class="['type-item', item === expect_status ? 'active' : '']"
              v-for="(item, index) in statusAll"
              :key="index"
              @click="expect_status = item;isActive();">
              {{item}}
            </div>
          </div>
        </div>

        <div class="btn">
          <button class="prev-btn" @click="$emit('prev')" v-show="!isClose" v-if="showPrev">上一步</button>
          <button :class="[isActiveSave || is_student ? 'active' : '']" @click="save">下一步</button>
        </div>
      </div>
    <!-- </transition> -->
  </div>
</template>
<script>
import selectBox from './select';
import {mapState} from 'vuex';
import api from '@/api';
import {dealSignatrue, get_tUser} from '@/assets/js/util';
import conditions from '@/assets/json/conditions';
import {cities, cityOne} from '@/assets/js/cities';
export default {
  name: 'intentionBox',
  components: {
    selectBox
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    // userIntentions: {
    //   type: Object,
    //   required: false
    // },
    isClose: false,
    showPrev: true,
  },
  data() {
    return {
      work_time_all: ['不限', '全职', '兼职', '实习'],
      work_time: '不限',
      industrie: ['不限'],
      categories: [],
      categorie: ['不限'],
      citiesIndex: 0,
      citie: ['全国'],
      cityList: [],
      expect_max_salary: '',
      expect_min_salary: '',
      expect_status: '',
      statusAll: ['离职-随时到岗', '在职-考虑机会', '在职-暂不考虑'],
      isActiveSave: false,
      is_student: false,
      conditionsData: {}
    };
  },
  computed: {
    ...mapState('jobs', ['intention', 'cities', 'userIntentions'])
  },
  watch: {
    userIntentions: {
      keep: true,
      immediate: true,
      handler: function (userIntentions) {
        userIntentions = JSON.parse(JSON.stringify(userIntentions));
        this.expect_max_salary = userIntentions.expect_max_salary || '';
        this.expect_min_salary = userIntentions.expect_min_salary || '';
        this.expect_status = userIntentions.expect_status || '';
        this.isActive();
        // this.industrie = userIntentions.industry_names;
        // this.categorie = userIntentions.profession_names;
        if (typeof userIntentions.work_time === 'string') {
          if (userIntentions.work_time === '不限' || userIntentions.work_time === '未开启')
          this.work_time = '不限';
          else
          this.work_time = userIntentions.work_time;
        } else {
          this.work_time = userIntentions.work_time && userIntentions.work_time[0]
        }

        if (typeof userIntentions.intention_cities === 'string') {
          if (!userIntentions.intention_cities || userIntentions.intention_cities === '未开启') {
	          this.citie = ['全国'];
          } else {
	          this.citie = [userIntentions.intention_cities] || ['全国'];
          }
        } else if (!userIntentions.intention_cities || !userIntentions.intention_cities[0]) {
          this.citie = ['全国'];
        } else {
          this.citie = userIntentions.intention_cities || ['全国'];
        }

        if (typeof userIntentions.profession_names === 'string') {
          if (!userIntentions.profession_names) this.categorie = ['不限'];
          else if (userIntentions.profession_names === '未开启') this.categorie = ['不限'];
          else this.categorie = [userIntentions.profession_names];
        } else {
          this.categorie = userIntentions.profession_names || ['不限'];
        }

        if (typeof userIntentions.industry_names === 'string') {
          if (!userIntentions.industry_names || userIntentions.industry_names === '未开启') {
	          this.industrie = ['不限'];
          } else {
	          this.industrie = [userIntentions.industry_names];
          }
        } else {
          this.industrie = userIntentions.industry_names || ['不限'];
        }
      }
    },
  },
  async created() {
    await (async () => {
	    let res = await api.me.getUserInfo(get_tUser().c_t);
	    if (res.code !== 1000) {
		    this.$message.error('网络出错，请重试');
		    return false;
	    }
	    this.is_student = res.data.is_student;
    })();
    // let res = await api.recruit.recruitInfosCategories();
    // let categories = ['最新', '热门', '互联网', '金融', '咨询', '快消', '电子', '房地产', '其他'];
    // categories.unshift('不限');
    // this.categories = categories;
    this.getIntention()
    // 获取城市
    let res1 = await api.recruit.toObtainCityNew({nums:0,job_count:0});
    let city = []
    Object.keys(res1.data).forEach((key,index)=>{
      let obj ={}
      obj.group_name = key=='hot_cities'?'热门城市':key;
      obj.part_cities = res1.data[key].map(item=>{
        item.id= item.city_id
        return item
      })
      city.push(obj)
    })
    let cities = city || [];
    let hot_cities = res1.data.hot_cities || [];
    hot_cities.unshift({city_name: '全国', id: 0});
    cities[0] = {group_name: '热门城市', part_cities: hot_cities};
    this.cityList = cities;
    this.$forceUpdate();
  },
  methods: {
  	// 获取职业类型
    async getProfessions () {
    	let res = await api.recruit.get_professions_hot_name()
      if (res.code === 1000) {
      	this.conditionsData.professions = res.data
      }
    },
    // 获取行业领域
    async getIndustries () {
    	let res = await api.recruit.get_industries_list()
      if (res.code === 1000) {
      	this.conditionsData.industries = res.data
      }
    },
    // 获取职位类型
    minChange(min) {
      if (min < 100) {
        this.expect_max_salary = min + 1;
      }
      else {
        this.expect_max_salary = '';
      }
    },
    isActive() {
      this.isActiveSave = false;
      let reg = /(^\d{1,8}$)|(^\d{1,8}.\d{1,2}$)/;
      if (!this.expect_min_salary) {
        return '请选择最低薪资';
      }
      if (this.expect_min_salary < 100 && !this.expect_max_salary) {
        return '请选择最高薪资';
      }
      // if (this.expect_max_salary < this.expect_min_salary) {
      //   return '最低薪资不应大于最高薪资';
      // }
      if (!this.expect_status) {
        return '请选择当前状态';
      }
      this.isActiveSave = true;
      return true;
    },
    // 获取求职意向
    async getIntention() {
      let userIntentionsQuery = await dealSignatrue();
      let userIntentions = await api.recruit.jobIntention(userIntentionsQuery);
      if (userIntentions.code && userIntentions.code === 1000) {
        await this.$store.dispatch('jobs/getIntention', userIntentions.data);
      }
	    await Promise.all([this.getProfessions(), this.getIndustries()])
      // 行业，筛选数据登
      this.intentionShow = true;
    },
    clone() {
      if (this.isClose) {
        return false;
      }
      this.$emit('clone');
    },
    selectCitie(data) {
      if (data === '全国') {
        this.citie = ['全国'];
        return false;
      }
      if (this.citie.indexOf(data) === -1) {
        this.citie.indexOf('全国') !== -1 && (this.citie = []);
        if (this.citie.length >= 3) {
          this.$message.warning('最多选择三个');
          return false;
        }
        this.citie.push(data);
      } else {
        this.citie.splice(this.citie.indexOf(data), 1);
        !this.citie.length && (this.citie = ['全国']);
      }
    },
    selectCategorie(data) {
      if (data === '不限') {
        this.categorie = ['不限'];
        return false;
      }
      if (this.categorie.indexOf(data) === -1) {
        this.categorie.indexOf('不限') !== -1 && (this.categorie = []);
        if (this.categorie.length >= 3) {
          this.$message.warning('最多选择三个');
          return false;
        }
        this.categorie.push(data);
      } else {
        this.categorie.splice(this.categorie.indexOf(data), 1);
        !this.categorie.length && (this.categorie = ['不限']);
      }
    },
    selectIndustrie(data) {
      if (data === '不限') {
        this.industrie = ['不限'];
        return false;
      }
      if (this.industrie.indexOf(data) === -1) {
        this.industrie.indexOf('不限') !== -1 && (this.industrie = []);
        if (this.industrie.length >= 3) {
          this.$message.warning('最多选择三个');
          return false;
        }
        this.industrie.push(data);
      } else {
        this.industrie.splice(this.industrie.indexOf(data), 1);
        !this.industrie.length && (this.industrie = ['不限']);
      }
    },
    // 获取行业领域的id
	  getIndustriesIds (data) {
    	let { industries } = this.conditionsData
      let ids = []
      industries.forEach(item => {
      	let index = data.findIndex(val => val === item.cn)
        if (index > -1) ids.push(item.id)
      })
      return ids
    },
    getProfessionIds (data) {
	    let { professions } = this.conditionsData
	    let ids = []
	    professions.forEach(item => {
		    let index = data.findIndex(val => val === item.name)
		    if (index > -1) ids = [ ...ids, ...item.results ]
	    })
	    return ids
    },
    // 获取职业类型的id
    async save() {
      if (!this.is_student && !this.isActiveSave) {
        this.$message.error(this.isActive());
        return false;
      }
      let cities = [];
      let citie = this.citie;
      let city = [];
      // 地址处理
      let cityList = JSON.parse(JSON.stringify(this.cityList));
      let temp = [];
      for (let i = 0; i < cityList.length; i++) {
        temp = temp.concat(cityList[i].part_cities);
      }
      for (let i = 0; i < citie.length; i++) {
        if (citie[i] === '全国') {
          break;
        }
        for (let j = 0; j < temp.length; j++) {
          if (citie[i] === temp[j].city_name) {
            cities.push(temp[j].id);
          }
        }
      }
      let data = {
	      industry_ids: this.getIndustriesIds(this.industrie) && this.getIndustriesIds(this.industrie),
	      profession_full_ids: this.getProfessionIds(this.categorie),
	      city_ids: [...new Set(cities)],
        expect_max_salary: this.expect_max_salary,
        expect_min_salary: this.expect_min_salary,
        expect_status: [ this.expect_status ],
      };
      data.industries = data.industries === '不限' ? '' : data.industries;
      data.professions = data.professions === '不限' ? '' : data.professions;
      data.work_time = data.work_time === '不限' ? '' : data.work_time;
      let res = await api.identity.updateInten(data);
      if (res.code === 1000) {
        this.$message.success('保存成功');
        // this.$emit('update');
        // this.$emit('clone');
        this.$emit('next')
        this.getIntention();
      }
      else {
        this.$message.error('保存失败');
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .intention-box-main {
    // position: fixed;
    // top: 0;
    // left: 0;
    // z-index: 9;
    .close {
      font-size: 22px;
      color: #404040;
      position: absolute;
      top: 31px;
      right: 32px;
      cursor: pointer;
      font-weight: 600;
    }
    .box {
      width:540px;
      height: 598px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 8px 0px rgba(0,0,0,0.13);
      border-radius:4px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      box-sizing: border-box;
      padding: 32px;
      font-size: 14px;
      .name {
        font-size: 16px;
        color: #404040;
      }
      .message {
        font-size: 14px;
        color: #606060;
        margin-top: 18px;
      }
      .title {
        color: #909090;
        font-size: 14px;
        height: 38px;
        line-height: 38px;
        margin-top: 6px;
      }
      .btn {
        display: flex;
        justify-content: flex-end;
        position: absolute;
        bottom: 32px;
        right: 32px;
        button {
          display: block;
          width: 80px;
          height: 38px;
          border: 1px solid #D9D9D9;
          color: #606060;
          font-size: 14px;
          border-radius: 2px;
          background: #fff;
          &.prev-btn:hover {
            border-color: #FF4F4C;
            color: #FF4F4C;
          }
          &.active {
            background: #FF453E;
            color: #fff;
            margin-left: 24px;
            border-color: #FF453E;
            &:hover {
              background: #FF716E;
              border-color: #FF716E;
            }
          }
        }
      }
      .type {
        display: flex;
        flex-wrap: wrap;
        .type-item {
          width:133px;
          height:40px;
          line-height: 40px;
          text-align: center;
          border-radius:2px;
          border:1px solid rgba(255,69,62,1);
          font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(255,69,62,1);
          margin-right: 16px;
          cursor: pointer;
          color: #909090;
          border-color: #CECECE;
          &.active {
            color: #FF453E;
            border-color: #FF453E;
          }
        }
      }
      .industries {
        display: flex;
        flex-wrap: wrap;
        padding: 20px 23px;
        padding-top: 4px;
        .item {
          width: 33.3%;
          margin-top: 16px;
          cursor: pointer;
          font-size: 14px;
          color: #606060;
          &.active {
            color: #FF453E;
          }
        }
      }
      .industries-input {
        display: flex;
        padding: 0 12px;
        .item {
          display: flex;
          align-items: center;
          margin-right: 20px;
          &:last-child {
            margin-right: 0;
          }
          .item-clone {
            display: block;
            width: 12px;
            height: 12px;
            border-radius: 6px;
            text-align: center;
            line-height: 12px;
            background: #FF453E;
            color: #fff;
            margin-left: 6px;
            background: #fff;
          }
          img {
            width: 12px;
            height: 12px;
            cursor: pointer;
          }
          .iconfont {
            position: relative;
            margin: 0;
            padding: 0;
            top: 0;
            right: 0;
            color: #fff;
            font-size: 10px;
            cursor: pointer;
          }
        }
      }
      .city {
        height: 208px;
        display: flex;
        overflow: hidden;
        &>div {
          height: 100%;
          overflow: auto;
        }
        .left-model {
          width: 76px;
          background: #F4F4F4;
          .item {
            width: 100%;
            height: 38px;
            line-height: 38px;
            text-align: center;
            cursor: pointer;
            flex: none;
            font-size: 13px;
            color: #606060;
            &.active {
              font-size: 14px;
              background: #fff;
              color: #404040
            }
          }
        }
        .right-model {
          width: calc(100% - 76px);
          height: fit-content;
          max-height: 100%;
          display: flex;
          align-items: flex-start;
          box-sizing: border-box;
          padding: 17px 8px 7px 30px;
          flex-wrap: wrap;
          margin: 0;
          .menu {
            height: 28px;
            line-height: 28px;
            padding: 0 18px;
            flex: none;
            flex-wrap: wrap;
            border: 1px solid #CCCCCC;
            color: #909090;
            font-size: 14px;
            cursor: pointer;
            margin-right: 14px;
            margin-bottom: 10px;
            border-radius: 2px;
            &.active {
              border-color: #FF4F4C;
              color: #FF4F4C;
            }
          }
        }
      }
      .salary {
        display: flex;
        align-items: center;
        .salary-item {
          width: 180px;
          height: 40px;
          border: 1px solid #CECECE;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          overflow: hidden;
          position: relative;
          input {
            width: 125px;
            height: 100%;
            flex: 1;
            padding-left: 12px;
            box-sizing: border-box;
          }
          .salary-item-text {
            color: #BCBCBC;
            flex: none;
            padding: 0 12px;
            position: absolute;
            top: 0;
            right: 0;
            height: 40px;
            line-height: 40px;
          }
        }
        .salary-text {
          padding: 0 16px;
          color: #404040;
          font-size: 14px;
        }
      }
    }
  }
</style>
<style lang="scss">
  .intention-box-main.cvs-intention {
    .salary {
      .el-input {
        width: 100%;
        border: none;
        .el-input__inner {
          border: none!important;
          .el-input__suffix {
            display: none!important;
          }
        }
        .el-input__suffix {
          display: none!important;
        }
      }
    }
  }
</style>
